module.exports = __webpack_public_path__ + "static/Logo Small Black-84e7ea8f2d4bc7e80bd1e4afa14d58b9.jpg";